import $ from 'jquery';
import ScrollLock from '../utils/ScrollLock';

export default class MobileNavigation {
  constructor(component) {
    this.el = component.el;
    this.$el = $(this.el);
    this.mobileDropdownButton = $('.nav-item.dropdown', this.el);
    this.mobileDropdown = $('.mobile-dropdown', this.el);
    this.sidebar = $('.mobile-dropdown--wrapper', this.el);
    this.mobileDropdownClose = $('[data-mobile-nav-close]', this.el);

    this.mobileDropdown.on('click.mobile-navigation', () => this.closeMobileNav());
    this.sidebar.on('click.mobile-navigation', e => e.stopPropagation());

    this.windowWidth = $(window).width();

    $('.dropdown > a .icon', this.el).on('click.mobile-navigation', this.toggleExpand.bind(this));
    $('.menu', this.el).on('click.mobile-navigation', () => this.toggleMobileNav());
    $(document).on('close-mobile-nav', this.closeMobileNav.bind(this));

    $(window).on('resize.mobile-navigation', () => {
      const isWidthIncrease = this.windowWidth !== $(window).width();
      if (($(window).width() > 720) && this.mobileDropdownButton.hasClass('active') && isWidthIncrease) {
        this.closeMobileNav();
      }
      this.windowWidth = $(window).width();
    });

    this.mobileDropdownClose.on('click', () => {
      this.closeMobileNav();
    });
  }

  openMobileNav() {
    this.mobileDropdownButton.addClass('active');
    this.mobileDropdownButton.attr('aria-expanded', true);
    this.mobileDropdown.addClass('active');

    $('.list.primary', this.mobileDropdown).css('overflow-y', 'hidden');
    $('.list.primary', this.mobileDropdown).css('overflow-y', 'auto');

    setTimeout(() => {
      window.scrollTo(0, document.body.scrollTop);
      ScrollLock.lock();
    }, 300);
  }

  closeMobileNav() {
    this.mobileDropdownButton.removeClass('active');
    this.mobileDropdownButton.attr('aria-expanded', false);
    this.mobileDropdown.removeClass('active');

    ScrollLock.unlock();
  }

  toggleMobileNav() {
    if (this.mobileDropdownButton.hasClass('active')) {
      this.closeMobileNav();
    } else {
      this.openMobileNav();
    }

    return false;
  }

  toggleExpand(e) {
    const button = $(e.currentTarget, this.el).parent().parent();
    const listItem = button.closest('li.list-item');
    const childList = button.find('> .list');

    e.preventDefault();

    listItem.toggleClass('expanded');
    childList.toggleClass('expanded');

    listItem.attr('aria-expanded', listItem.hasClass('expanded'));

    setTimeout(() => {
      $('.list.primary', this.mobileDropdown).css('overflow-y', 'hidden');
      $('.list.primary', this.mobileDropdown).css('overflow-y', 'auto');
    }, 350);
  }

  unload() {
    $('.dropdown > a', this.el).off('click.mobile-navigation');
    $('.nav-item.dropdown', this.el).off('click.mobile-navigation');
    $(document).off('close-mobile-nav');
    $(window).off('resize.mobile-navigation');
    document.body.removeEventListener('touchmove', this.preventBodyScroll());
  }
}
